import { InboxAtlasRoute } from '../../core/src/lib/interface/inbox.interface';

export const INBOX_NAVIGATION_LINK_FULLSCREEN = ['inbox'];
export const INBOX_NAVIGATION_LINK = ['', { outlets: { inbox: ['inbox'] } }];
export const INBOX_TEMPLATES_ROUTER_LINK = <InboxAtlasRoute>[
  '',
  { outlets: { inbox: ['inbox', 'settings', 'message-templates'] } },
];

export const DEFAULT_MESSAGE_GROUPING_DURATION = 60000 * 10; // 10 minutes in milliseconds
export const DEFAULT_HOUR_GROUP_DURATION = 60000 * 60 * 3; // 3 hours in milliseconds

export const FETCH_SCREEN_CONTENT_TOOL_CALL_NAME = 'fetchScreenContent';
export const DIRECT_TOOL_CALL_REQUEST_KEY = 'toolCallRequest/v1';
